var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/promo_panel.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React from 'react';
import { Widget, Stack, Text } from 'soapbox/components/ui';
import { useSettings, useSoapboxConfig } from 'soapbox/hooks';
const PromoPanel = () => {
  const {
    promoPanel
  } = useSoapboxConfig();
  const settings = useSettings();
  const promoItems = promoPanel.get('items');
  const locale = settings.get('locale');
  if (!promoItems || promoItems.isEmpty()) return null;
  return /*#__PURE__*/React.createElement(Widget, {
    title: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }, promoItems.map((item, i) => /*#__PURE__*/React.createElement(Text, {
    key: i,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: "flex items-center",
    href: item.url,
    target: "_blank",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-lg mr-2 grayscale",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 15
    }
  }, item.icon), item.textLocales.get(locale) || item.text)))));
};
export default PromoPanel;